<template>
    <u-dialog v-model="shows" title="이용약관" persistent width="600">
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, isValid }" />
        </template>
        <div v-if="isLoaded">
            <u-tit-wrap-x-small>
                <v-checkbox v-model="isValid" v-bind="{ ...attrs_controls_common }" label="약관에 전체 동의합니다." readonly @click="toggleSelectedAll" />
            </u-tit-wrap-x-small>
            <v-divider />

            <div v-for="term in termsList" :key="term._id" class="pt-16px pt-md-24px">
                <u-tit-wrap-x-small>
                    <template #titleContents>
                        {{ term.subject }}에 동의<span class="pl-4px" :class="[term.necessary ? 'red--text' : 'grey--text text--lighten-1']">({{ term.necessary ? "필수" : "선택" }})</span>
                    </template>
                    <v-checkbox v-model="selected" v-bind="{ ...attrs_controls_common }" :value="term._id" label="약관동의" class="v-input--density-comfortable" />
                </u-tit-wrap-x-small>
                <v-card v-bind="{ ...card_primary }">
                    <div class="px-16px py-md-12px mh-120px" style="overflow-y: auto">
                        <txt-primary txtSize="txt--sm">
                            <div v-html="term.content.replace(/\n/gi, '<br/>')" />
                        </txt-primary>
                    </div>
                </v-card>
            </div>

            <div class="btn-wrap btn-wrap--sm">
                <v-row justify="center" class="row--xs">
                    <v-col>
                        <v-btn v-bind="{ ...btn_tertiary }" x-large block @click="cancel">취소하기</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn v-bind="{ ...btn_primary }" x-large block @click="agree">동의하기</v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </u-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_controls_common, btn_primary, btn_tertiary, card_primary } from "@/assets/variables";

import PageSection from "@/components/client/templates/page-section.vue";
import UDialog from "@/components/client/dumb/u-dialog.vue";
import UTitWrapXSmall from "@/components/publish/styles/typography/u-tit-wrap-x-small.vue";
import VPreviewInput from "@/components/plugins/vuetify/v-preview-input.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

export default {
    components: {
        PageSection,
        UDialog,
        UTitWrapXSmall,
        VPreviewInput,
        TxtPrimary,
    },
    props: {
        value: { type: Array, default: () => [] },
        params: { type: Object, default: () => ({}) },
    },
    data: () => ({
        attrs_input,
        attrs_controls_common,
        btn_primary,
        btn_tertiary,
        card_primary,

        shows: false,
        isLoaded: false,
        selected: [],
        termsList: [],
    }),
    computed: {
        isValid() {
            return !this.termsList.some(({ _id }) => !this.selected.includes(_id));
        },
    },
    created() {
        this.init();
    },
    mounted() {
        this.selected = this.value;
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },

        isLoaded(isLoaded) {
            if (isLoaded) this.$emit("isLoaded", this.termsList);
        },
    },
    methods: {
        async init() {
            try {
                this.isLoaded = false;

                let { params } = this;
                var { termsList } = await api.v1.terms.gets({ params });
                this.termsList = termsList;

                this.isLoaded = true;
            } catch (error) {
                this.$handleError(error);
            }
        },

        toggleSelectedAll() {
            if (this.isValid) this.selected = [];
            else this.selected = this.termsList.map(({ _id }) => _id);
        },
        cancel() {
            this.selected = this.value;
            this.shows = false;
        },
        agree() {
            this.$emit("input", this.selected);
            this.$emit("isValid", this.isValid);
            this.shows = false;
        },
    },
};
</script>

<style></style>
